import { isEmpty, isObject, pickBy, snakeCase, transform } from "lodash-es";

// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze#examples
export const deepFreeze = <T extends object>(object: T): Readonly<T> => {
  // Retrieve the property names defined on object
  const propNames = Reflect.ownKeys(object) as (keyof T)[];
  // Freeze properties before freezing self
  for (const name of propNames) {
    const value = object[name];
    if ((value && typeof value === "object") || typeof value === "function") {
      deepFreeze(value);
    }
  }
  return Object.freeze(object);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const keysToSnakeCase = (obj: unknown): any =>
  obj
    ? transform(
        obj,
        (result: Record<string, unknown>, value: unknown, key: string) => {
          const snakeKey = snakeCase(key);
          result[snakeKey] = isObject(value)
            ? keysToSnakeCase(value as Record<string, unknown>)
            : value;
        },
      )
    : null;

export const isObjectEmpty = (obj?: object): boolean =>
  !obj || isEmpty(pickBy(obj));
